import { ICellRendererParams } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

import { BillableShippedRow, BillingStatus } from '../utils/columnDefs';

const statusColors: Record<BillingStatus, string> = {
  verified: 'bg-green-500 text-white',
  reconciled: 'bg-blue-500 text-white',
  notReconciled: 'bg-red-500 text-white',
  incomplete: 'bg-gray-500 text-white',
};

export const BillingStatusRenderer = (
  params: ICellRendererParams<BillableShippedRow>,
) => {
  const { t } = useTranslation();
  const billingStatus = params.data?.billingStatus;
  const isOverridden = params.data?.billableShippedOverridden ?? false;
  const reconciliationDiff = params.data?.reconciliationDiff ?? 0;

  if (!billingStatus) return null;

  const getTooltip = () => {
    if (billingStatus !== 'notReconciled') return undefined;
    if (reconciliationDiff > 0)
      return t('billableShipped.unaccounted', { count: reconciliationDiff });
    if (reconciliationDiff < 0)
      return t('billableShipped.exceedsBy', {
        count: Math.abs(reconciliationDiff),
      });
    return undefined;
  };

  const label = t(`billableShipped.status.${billingStatus}`);

  return (
    <span className="flex h-full w-full items-center gap-1">
      <span
        className={`flex flex-1 items-center justify-center rounded-md px-3 py-1 text-sm font-medium ${statusColors[billingStatus]}`}
        title={getTooltip()}
      >
        {label}
      </span>
      {isOverridden && (
        <span className="flex items-center justify-center rounded-md bg-purple-500 px-2 py-1 text-sm font-medium text-white">
          {t('billableShipped.status.overridden')}
        </span>
      )}
    </span>
  );
};
